import SingleBanner from "./SingleBanner";
import styles from "./Banner.module.css";
import DoubleBannerWrapper from "./DoubleBanners/DoubleBannerWrapper";
import BannerSlider from "./BannerSlider";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const Banner = ({ data }) => {
  const navigate = useLangNavigate();

  return (
    <>
      {(data?.name === "top-images" || data?.name === "bottom-images") &&
      data.sections.length === 1 ? (
        data.sections.map((banner) => {
          return (
            <div
              className={
                data?.name === "top-images"
                  ? styles.TopImage
                  : styles.BottomImage
              }
              key={banner?.url}
            >
              <SingleBanner
                external_url={banner?.images[0].external_url}
                internal_url={banner?.images[0].internal_url}
                url={banner?.url}
                image_url={banner.images?.[0]?.url}
                onClick={() => {
                  const product_id =
                    banner.images?.[0]?.reference_product.values?.[0]
                      ?.reference;
                  if (product_id) {
                    navigate(`/product/${product_id}`);
                  } else if (banner.url) {
                    navigate(banner.url);
                  }
                }}
              />
            </div>
          );
        })
      ) : (data?.name === "top-images" || data?.name === "bottom-images") &&
        data.sections.length > 1 ? (
        <div
          className={
            data?.name === "top-images" ? styles.TopImage : styles.BottomImage
          }
          style={{ padding: "0 8px", marginTop: "8px" }}
        >
          <BannerSlider bannerGroup={data} />
        </div>
      ) : data?.name === "merged-image" ? (
        <div className={styles.BannerContainer}>
          {data.images.map((image) => {
            return (
              <DoubleBannerWrapper
                image_url={image.url}
                className={styles.Left}
                is_external_url={data.external_url}
                external_url={data.url}
                onClick={() => {
                  const product_id =
                    image.reference_product.values?.[0]?.reference;
                  if (product_id) {
                    navigate(`/product/${product_id}`);
                  } else if (data.url) {
                    navigate(data.url);
                  }
                }}
                key={image.url}
              />
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default Banner;
